// extracted by mini-css-extract-plugin
export default {"container":"_-_-record-it-components-src-map-BasemapMap-__container"};